lmApp.service('DeviceResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/devices',
    null,
    {
      get: {
        url: '/discovery:80/sdp/v2/devices?$expand=platform',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      }
    }
  );
}]);